import { useRoute } from '@react-navigation/native';
import { Box } from 'native-base';
import { useEffect, useState } from 'react';
import { Dimensions, DimensionValue } from 'react-native';

import {
  TableHeadContainer,
  TableHeadItem,
  TableHeadItemRecurse,
} from '../../../../../components/TableHead';

import { LoadingTable } from './constants';

export const renderDynamicTableHead = (tableHeadItems: TableHeadItemRecurse<any>[]) => (
  <TableHeadContainer px="inline.xxxs" marginBottom="inset.nano">
    {tableHeadItems.map((item, index) => (
      <TableHeadItem key={`${item.title}-${index}`} {...item} value={item.orderValue} />
    ))}
  </TableHeadContainer>
);

export const renderDynamicLoadingFooter = (
  loading: boolean,
  tableHeadItems: TableHeadItemRecurse<any>[]
) => {
  return <Box>{!!loading && <LoadingTable items={1} columnsItems={tableHeadItems} />}</Box>;
};

const alwaysSubtractFromHeightInline = 70;
const alwaysSubtractFromHeightNotInline = 295;
const maxProductsBeforeScroll = 10;
const averageProductItemHeight = 90;
const maxHeightForAssetList = maxProductsBeforeScroll * averageProductItemHeight;

export const useDynamicTableMaxHeight = () => {
  const route = useRoute();
  const [maxHeight, setMaxHeight] = useState<DimensionValue>(0);

  useEffect(() => {
    const isInline = route.name === 'CustomerDetail';

    const subscription = Dimensions.addEventListener('change', ({ window }) => {
      if (isInline) {
        setMaxHeight(maxHeightForAssetList - alwaysSubtractFromHeightInline * 1.8);
      } else {
        setMaxHeight(window.height - alwaysSubtractFromHeightNotInline);
      }
    });

    if (isInline) {
      setMaxHeight(maxHeightForAssetList - alwaysSubtractFromHeightInline * 1.8);
    } else {
      setMaxHeight(Dimensions.get('window').height - alwaysSubtractFromHeightNotInline);
    }

    return () => {
      subscription.remove();
    };
  }, [route.name]);

  return maxHeight;
};

export const useHeightForAssetList = (data: any[] | null | undefined, isInline?: boolean) => {
  const [nonInlineHeight, setNonInlineHeight] = useState<DimensionValue>(0);

  useEffect(() => {
    const subscription = Dimensions.addEventListener('change', ({ window }) => {
      setNonInlineHeight(window.height - alwaysSubtractFromHeightInline);
    });

    setNonInlineHeight(Dimensions.get('window').height - alwaysSubtractFromHeightInline);

    return () => {
      subscription.remove();
    };
  }, []);

  if (isInline) {
    if (!data) {
      return undefined;
    }

    return data.length > maxProductsBeforeScroll ? maxHeightForAssetList : undefined;
  }

  return nonInlineHeight;
};
